import Blue from "~/core";

new Blue({
	name: 'Tabbed Content',
	selector: ".tabs",
	setup(tabsContainer) {
    const tabLinks = [...tabsContainer.querySelectorAll("a.tabs__option-link")];
		const tabContentBlocks = tabLinks.map(link => document.querySelector(link.getAttribute("href")));
		const tabList = tabsContainer.querySelector("ul.tabs__option-list");
		const nav = tabsContainer.querySelector("nav.tabs__nav");
		let initialLoad = true;

		const setActive = (link, i) => {
			if (link.matches(".active-tab")) return;
			tabsContainer.querySelector("a.active-tab")?.classList.remove("active-tab");
			document.querySelector(".active-tab-content")?.classList.remove("active-tab-content");
			link.classList.add("active-tab");
			tabContentBlocks[i].classList.add("active-tab-content");
			let linkText = link.textContent;
			let baseURL = window.location.origin + window.location.pathname;
			let dest = link.getAttribute('href');
			if (!initialLoad) history.pushState({}, linkText, baseURL + dest);
		}

		// If user refreshes page or is linked to page with specific hash value, select the current hash value
		if (!!window.location.hash) {
			let currentHashLink = tabLinks.find(link => link.getAttribute("href") == window.location.hash) || false;
			if (currentHashLink) {
				setActive(currentHashLink, tabLinks.indexOf(currentHashLink));
				if (nav.offsetWidth < tabList.scrollWidth) {
					let linkDistRight = currentHashLink.getBoundingClientRect().right - nav.offsetWidth;
					tabList.scrollLeft = linkDistRight;
				}
			}	else {
				setActive(tabLinks[0], 0);
			}
		} else {
			setActive(tabLinks[0], 0);
		}
		initialLoad = false;
		
		// Add event listener for each link
		tabLinks.forEach((link, i) => {
			this.$addEvents(link, "click.prevent", () => {
				setActive(link, i);
			});
		});

		// Set classes on nav element that add gradient(s) as visual cure to user that the tab list can be scrolled
		const setShadowClasses = () => {
			if (nav.offsetWidth >= tabList.scrollWidth) {
				nav.classList.remove("more-to-left");
				nav.classList.remove("more-to-right");
				return;
			}
			const scrollDiff = tabList.scrollWidth - nav.offsetWidth;
			if (tabList.scrollLeft > 5) nav.classList.add("more-to-left");
			else nav.classList.remove("more-to-left");
			if (tabList.scrollLeft <= scrollDiff - 5) nav.classList.add("more-to-right");
			else nav.classList.remove("more-to-right");
		}

		setShadowClasses();
		this.$addEvents(tabList, "scroll", setShadowClasses);
		this.$addEvents(window, "resize", setShadowClasses);
	}
});